import { render } from "./modal.vue?vue&type=template&id=dbf6e220&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=dbf6e220&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dbf6e220"

export default script